import RequestAbstract from "../abstract";

export default class ExportCsvTasks extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/export-tasks';
    }
}
